export enum PAGINATION {
  PAGE = 1,
  LIMIT = 10,
}
